import { Component, OnInit , Inject} from '@angular/core';
import { CommonmastersService } from "../../../../commonmasters/commonmasters.service";
import { PrinttrailbalanceService } from "../../print/printtrailbalance.service";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToasterserviceService } from "../../../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../../../utility/shared/toastpayload";

@Component({
  selector: 'app-rpttrailbalancepopup',
  templateUrl: './rpttrailbalancepopup.component.html',
  styleUrls: ['./rpttrailbalancepopup.component.css']
})

export class RpttrailbalancepopupComponent implements OnInit {

  BranchList: any[] = [];
  toast : Toastpayload;

  constructor(private commonmastersService: CommonmastersService,
    private printtrailbalanceService: PrinttrailbalanceService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RpttrailbalancepopupComponent>,
    private toasterserviceService: ToasterserviceService) { }

  ngOnInit() {
    this.GetBranchList();
    this.data.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
  }

  GetBranchList() {
    this.commonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;
    })
  }

  GenerateReports(): void {
    this.data.ReportName = "TrialBalanceReport";  
    this.printtrailbalanceService.GenerateReport(this.data);
    this.dialogRef.close();

    // toastr Notification
    this.toast = {
      message: "Please wait, the report is loading in the new tab!",
      title: 'Report', 
      ic:  {
        timeOut: 5000,
        closeButton: true,
      } as IndividualConfig,
      type: 'info',    
    };

    // this.toast.type = 'info';
    this.toasterserviceService.showToast(this.toast);
  }

}
